<template>
    <header id="app-header" class="border-b border-[#EBF1F9]">
        <div class="mx-auto w-[100%] sm:w-[90%] min-w-[290px] max-w-[1170px] flex h-[55px] sm:h-[70px] items-center justify-between">
            <div>
                <img src="/images/campaigns/logo.svg" class="w-[100px] sm:w-[132px]" alt="Nova logo">
            </div>

            <div class="flex items-center min-w-[150px]">
                <img src="/images/campaigns/google-logo-icon.svg" class="w-[30px] lg:w-[33px] mr-2" alt="Google logo icon" />

                <div>
                <img src="/images/campaigns/rating-stars.svg" alt="Google's rating stars" class="h-[13px] lg:h-[14px]" />

                <p class="text-[#1B2F51] text-[11px] lg:text-[12px]">
                    <span class="font-semibold">4.8/5</span> • 82 reviews
                </p>
                </div>
            </div>
        </div>
    </header>
</template>

<style scoped>
#app-header {
    background-color: #fff;
}

@media screen and (min-width: 640px) {
    #app-header {
        background-color: transparent;
    }
}
</style>
<script setup>
</script>
